/*
 * @Version: 1.0
 * @Autor: wenruihuan
 * @Date: 2022-04-01 00:44:28
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-04-21 02:03:42
 */
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

export default new Router({
  mode: 'hash', //去掉#号
  routes: [{
      path: '/login',
      name: 'loginPage',
      component: resolve => require(['../views/login.vue'], resolve)
    },
    {
      path: '/',
      name: 'yxzt',
      children: [
        {
          // 运行状态
          path: '/yxzt',
          name: 'yxzt',
          component: resolve => require(['../views/yxzt/index.vue'], resolve)
        },
        {
          // 运行状态
          path: '/cssz',
          name: 'cssz',
          component: resolve => require(['../views/cssz/index.vue'], resolve)
        },
        {
          // 运行记录
          path: '/yxjl',
          name: 'yxjl',
          component: resolve => require(['../views/yxjl/index.vue'], resolve)
        },
        {
          // 远程设置
          path: '/ycsz',
          name: 'ycsz',
          component: resolve => require(['../views/ycsz/index.vue'], resolve)
        },
        {
          // 远程设置
          path: '/xxzz',
          name: 'xxzz',
          component: resolve => require(['../views/xxzz/index.vue'], resolve)
        },
        {
          // 定时任务
          path: '/dsrw',
          name: 'dsrw',
          component: resolve => require(['../views/dsrw/index.vue'], resolve)
        },
        {
          // 时实任务
          path: '/ssrw',
          name: 'ssrw',
          component: resolve => require(['../views/ssrw/index.vue'], resolve)
        },
        {
          // 资源管理
          path: '/zygl',
          name: 'zygl',
          component: resolve => require(['../views/zygl/index.vue'], resolve)
        },
        {
          //  播放设置
          path: '/bfsz',
          name: 'bfsz',
          component: resolve => require(['../views/bfsz/index.vue'], resolve)
        }
      ],
      component: resolve => require(['../views/index.vue'], resolve)
    }
  ]
})